import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import Tag from '@/modules/base/components/tag/tag'

const TagCell = (props) => {
  const { data: { tags } = {} } = props
  const classes = useStyles()

  const tagArray = (tags || []).map((tag) => {
    return <Tag key={tag.id} label={tag.label} />
  })

  return (
    <div className={classes.tagCellWrapper}>
      {tagArray}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  tagCellWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    height: 50,
  },
}))

TagCell.propTypes = {
  data: PropTypes.object,
}

export default TagCell
